webpackJsonp([135728916539164],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/page-2.json":
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---page-2-a0e39f21c11f6a62c5ab.js